/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon24Solid = forwardRef('ArrowCRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.44 2.942a1.5 1.5 0 0 1 2.12 0l6.407 6.406a3.75 3.75 0 0 1 0 5.303l-6.406 6.407a1.5 1.5 0 0 1-2.122-2.121l6.407-6.407a.75.75 0 0 0 0-1.06L7.44 5.063a1.5 1.5 0 0 1 0-2.121Z" })));
});
